import { FC } from 'external/react';
import useAdmin from 'context/admin-context/hook';
import { CourseMap } from 'types/course';

import Header from './Header'
import Footer from './Footer'
import Dropdowns from './Dropdowns'

import CoursePreview from './CoursePreview';

type ChangeCourseModalProps = {
  onSave: (newCourse: any) => void;
};

const ChangeCourseModal: FC<ChangeCourseModalProps> = ({ onSave }) => {
  const { state, changeCourseModal, updateChangeCourseModal } = useAdmin();

  const { selected } = changeCourseModal ?? {};

  const originalCourse = changeCourseModal?.originalCourse ?? '';
  const courseId  = selected?.course  ?? '';

  const hasChanged = !!courseId && courseId !== originalCourse;
  const canSave    = hasChanged;

  const handleSave = () => {
    if (!courseId || !hasChanged) return;
    const {originalCourse, source } = changeCourseModal
    updateChangeCourseModal(
      false,
      null,
      originalCourse,
      { subject: '', grade: '', course: '',  source: ''},
      () => onSave({ originalCourse, newCourse: courseId, source})
    );
  };

  const handleClose = () => updateChangeCourseModal(false, null, undefined, { subject: '', grade: '', course: '', source: '' }, null);

  // ── Render ─────────────────────────────────────────────────────────────────

  if (!changeCourseModal?.open) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={handleClose}
        style={{
          position: 'fixed', inset: 0,
          background: 'rgba(15, 23, 42, 0.45)',
          backdropFilter: 'blur(3px)',
          zIndex: 1040,
          animation: 'ccmFadeIn 150ms ease',
        }}
      />

      {/* Panel */}
      <div style={{
        position: 'fixed',
        top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1050,
        width: '100%',
        maxWidth: 500,
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 24px 60px rgba(0,0,0,0.18)',
        overflow: 'hidden',
        animation: 'ccmSlideUp 220ms cubic-bezier(0.16,1,0.3,1)',
        fontFamily: "'Nunito', 'Segoe UI', sans-serif",
      }}>
        <Header />

        {/* Body */}
        <div style={{ padding: '22px 24px' }}>
          <CoursePreview originalCourse={originalCourse} courseId={courseId} hasChanged={hasChanged} />
          <Dropdowns />
       </div>
        <Footer canSave={canSave} handleSave={handleSave} />
     </div>
      <style>{`
        @keyframes ccmFadeIn  { from { opacity: 0 } to { opacity: 1 } }
        @keyframes ccmSlideUp {
          from { opacity: 0; transform: translate(-50%, calc(-50% + 18px)); }
          to   { opacity: 1; transform: translate(-50%, -50%); }
        }
      `}</style>
    </>
  );
};

export default ChangeCourseModal;